import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Loader } from "cxa-components";

import { loadLibraryItem } from "actions/libraryCatalogueActions";

class CatalogueItemDetail extends Component {
  componentDidMount() {
    const { loadLibraryItem, itemId } = this.props;
    loadLibraryItem(itemId);
    this.scrollToTop();
  }

  scrollToTop = () => {
    window.scrollTo(0, 0);
  }

  render() {
    const { fetching } = this.props;
    const libItem = this.props.libraryItem.content;
    if (fetching || !libItem) {
      return <Loader />;
    }

    let coverImage;

    if (libItem && libItem.imageMainFull && libItem.imageMainFull !== "") {
      coverImage = (
        <figure>
          <img src={libItem.imageMainFull} alt="" />
        </figure>
      );
    }

    return (
      <article className="card">
        <header>
          <h2>
            {libItem.title}
          </h2>
        </header>
        <section>
          {!!coverImage && coverImage}
          <div dangerouslySetInnerHTML={{ __html: libItem.body }} />
        </section>
      </article>
    );
  }
}

CatalogueItemDetail.propTypes = {
  params: PropTypes.object,
  libraryItem: PropTypes.object,
  itemKey: PropTypes.string,
  loadLibraryItem: PropTypes.func,
  itemId: PropTypes.string,
  fetching: PropTypes.bool,
};

const mapDispatchToProps = {
  loadLibraryItem,
};

const mapStateToProps = (
  { libraryItem: { data, error, fetched, fetching } },
  { match: { params: { itemId } } }
) => ({
  error,
  libraryItem: data,
  fetched,
  fetching,
  itemId,
});

export default connect(mapStateToProps, mapDispatchToProps)(
  CatalogueItemDetail
);



// WEBPACK FOOTER //
// ./components/elibrary/CatalogueItemDetailPage.js